import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificacaoDto } from '@usucampeao/lib-reurb-simplificado';
import { AuthQuery } from '../../../auth/state/auth.query';

@Component({
  selector: 'usucampeao-vencimento-amanha',
  templateUrl: './vencimento-amanha.component.html',
  styleUrls: ['./vencimento-amanha.component.scss'],
})
export class VencimentoAmanhaComponent {
  @Input()
  public notification!: NotificacaoDto;
  public nomeUsuario$ = this.authQuery.meName$;
  @Output() goto = new EventEmitter();

  constructor(
    private authQuery: AuthQuery
  ) { }

  goRegister() {
    this.goto.emit(this.notification);
  }

}